/**
 * Product Gallery Dots Functionality
 * Handles dot indicator clicks and updates active states
 */

class ProductGalleryDots {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupDots());
    } else {
      this.setupDots();
    }
  }

  setupDots() {
    const mediaGalleries = document.querySelectorAll('media-gallery');
    
    mediaGalleries.forEach(gallery => {
      const sectionId = gallery.id.replace('MediaGallery-', '');
      const dotsContainer = document.getElementById(`GalleryDots-${sectionId}`);
      const sliderComponent = gallery.querySelector('slider-component');
      const slider = gallery.querySelector('[id^="Slider-Gallery"]');
      
      if (!dotsContainer || !slider || !sliderComponent) return;
      
      this.bindDotEvents(dotsContainer, slider, sliderComponent, sectionId);
      this.setupSliderEventListeners(sliderComponent, dotsContainer, slider);
      
      // Initial dot update
      setTimeout(() => this.updateActiveDot(slider, dotsContainer), 100);
    });
  }

  bindDotEvents(dotsContainer, slider, sliderComponent, sectionId) {
    const dots = dotsContainer.querySelectorAll('.gallery-dot');
    const slides = slider.querySelectorAll('.product__media-item');
    
    dots.forEach((dot, index) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Get the slide index from data attribute
        const slideIndex = parseInt(dot.getAttribute('data-slide-index'));
        const targetSlide = slides[slideIndex];
        
        if (targetSlide && sliderComponent) {
          // Use the slider component's scroll method for proper navigation
          const slideWidth = targetSlide.offsetWidth;
          const scrollPosition = slideIndex * slideWidth;
          
          // Scroll the slider to the target position
          slider.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
          });
          
          console.log(`Clicked dot ${index + 1}, navigating to slide ${slideIndex + 1}`);
        }
      });
    });
  }

  setupSliderEventListeners(sliderComponent, dotsContainer, slider) {
    // Listen to the official slideChanged event from SliderComponent
    sliderComponent.addEventListener('slideChanged', (event) => {
      console.log('Slide changed event:', event.detail);
      this.updateActiveDotFromSliderEvent(event.detail, dotsContainer);
    });

    // Also listen for scroll events as a fallback
    slider.addEventListener('scroll', () => {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.updateActiveDotFromScroll(slider, dotsContainer);
      }, 150);
    });

    // Listen for touch events on mobile
    this.setupTouchHandling(slider, dotsContainer);
  }

  setupTouchHandling(slider, dotsContainer) {
    let touchStartTime = 0;
    
    slider.addEventListener('touchstart', () => {
      touchStartTime = Date.now();
    });
    
    slider.addEventListener('touchend', () => {
      const touchDuration = Date.now() - touchStartTime;
      
      // Only update dots after a swipe gesture (not a tap)
      if (touchDuration > 100) {
        setTimeout(() => {
          this.updateActiveDotFromScroll(slider, dotsContainer);
        }, 300);
      }
    });
  }

  updateActiveDotFromSliderEvent(eventDetail, dotsContainer) {
    const dots = dotsContainer.querySelectorAll('.gallery-dot');
    const currentPage = eventDetail.currentPage;
    
    // Update dots based on current page (1-indexed)
    dots.forEach((dot, index) => {
      dot.classList.remove('active');
      if (index === currentPage - 1) {
        dot.classList.add('active');
      }
    });
    
    console.log(`Updated dots from slider event: page ${currentPage}/${dots.length}`);
  }

  updateActiveDotFromScroll(slider, dotsContainer) {
    const slides = Array.from(slider.querySelectorAll('.product__media-item'));
    const dots = dotsContainer.querySelectorAll('.gallery-dot');
    
    if (slides.length === 0 || dots.length === 0) return;
    
    // Calculate which slide is most visible
    const scrollLeft = slider.scrollLeft;
    const slideWidth = slides[0].offsetWidth;
    const currentIndex = Math.round(scrollLeft / slideWidth);
    
    // Update dots
    dots.forEach((dot, index) => {
      dot.classList.remove('active');
      if (index === currentIndex) {
        dot.classList.add('active');
      }
    });
    
    console.log(`Updated dots from scroll: slide ${currentIndex + 1}/${dots.length}`);
  }

  updateActiveDot(slider, dotsContainer) {
    // This method is now mainly used for initial setup
    this.updateActiveDotFromScroll(slider, dotsContainer);
  }

  updateSliderCounter(sectionId, currentSlide) {
    const counterCurrent = document.querySelector(`#GalleryViewer-${sectionId} .slider-counter--current`);
    if (counterCurrent) {
      counterCurrent.textContent = currentSlide;
    }
  }
}

// Initialize when script loads
new ProductGalleryDots();

// Also initialize when page is loaded via AJAX (for theme sections)
document.addEventListener('shopify:section:load', () => {
  new ProductGalleryDots();
});
